import { render, staticRenderFns } from "./AssociatedWorkPartner.vue?vue&type=template&id=026a86b8&"
import script from "./AssociatedWorkPartner.vue?vue&type=script&lang=js&"
export * from "./AssociatedWorkPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports